module.exports = function() {
  return new Worker(__webpack_public_path__ + "ec1496360bd91c81984f.worker.js");
};